export * from './datadog-edge-adapter';
